export default __webpack_public_path__ + "static/media/fullscreen.eab5064c.svg";